// extracted by mini-css-extract-plugin
module.exports = {"table-requests":"SortableTableSentApplications_table-requests__xkT6I","application-status":"SortableTableSentApplications_application-status__3MR2J"};